import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="htmlwebviewelement" id="htmlwebviewelement"></a>
    <h1 {...{
      "id": "windowhtmlwebviewelement"
    }}>{`window.HTMLWebViewElement`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`: v6.0  `}</p>
    <a name="new-htmlwebviewelement-new" id="new-htmlwebviewelement-new"></a>
    <h2 {...{
      "id": "htmlwebviewelement"
    }}>{`HTMLWebViewElement()`}</h2>
    <p>{`WebViews is a component that allows you to embed web content in your plugins. It is essentially a browser window that is displayed inside UXP plugin, allowing you to load web pages, and interact with it using JavaScript.`}</p>
    <p>{`WebViews can be used to display complex web pages inside the UXP plugins. You can use it to access external web services, to create custom UI and to isolate the web content from the rest of the plugin.`}<br></br></p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`WebViews are resource intensive since it launches multiple processes per plugin
and therefore should be used only in cases where you cannot create the plugin using UXP features.`}<br></br></p>
    <h3 {...{
      "id": "getting-started"
    }}>{`Getting started`}</h3>
    <p>{`Webview takes attributes such as `}<inlineCode parentName="p">{`id`}</inlineCode>{` , `}<inlineCode parentName="p">{`height`}</inlineCode>{` , and `}<inlineCode parentName="p">{`src`}</inlineCode>{` to specify its properties. Add a WebView element by using the following code example in the desired location.`}<br></br></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`<webview id="webviewsample" width="100%" height="360px" src="https://www.adobe.com" uxpAllowInspector="true" ></webview>
`}</code></pre>
    <h4 {...{
      "id": "manifest-settings"
    }}>{`Manifest Settings`}</h4>
    <p>{`To configure the Webview, you will first require the `}<inlineCode parentName="p">{`webview`}</inlineCode>{` permission for your plugin. And configure the `}<inlineCode parentName="p">{`domains`}</inlineCode>{`, `}<inlineCode parentName="p">{`allow`}</inlineCode>{`, `}<inlineCode parentName="p">{`allowLocalRendering`}</inlineCode>{` and `}<inlineCode parentName="p">{`enableMessageBridge`}</inlineCode>{` attributes in manifest. The role of each of these attributes are described below.`}</p>
    <p><strong parentName="p">{`Note`}</strong>{` that WebViews require manifest version v5 or above `}<br></br></p>
    <table columnWidths="20,10,50,20">
 <tr>
     <th>Key</th>
     <th>Value</th>
     <th>Description</th>
     <th>Mandatory/Optional</th>
      </tr>
      <tr>
     <td>.allow</td>
     <td>"yes"</td>
     <td>Enables WebView access to the plugin</td>
     <td>Mandatory</td>
      </tr>
      <tr>
     <td>.allowLocalRendering</td>
     <td>"yes"</td>
     <td>Enables WebView to load local contents (supported from UXP v8.0.0❗) </td>
     <td>Optional</td>
      </tr>
      <tr>
     <td>.domains</td>
     <td>string[]</td>
     <td>Allows access to the specified domains. Wildcards (except top-level) are supported. e.g "https://*.adobe.com". <br></br> Recommended</td>
     <td>Mandatory</td>
      </tr>
      <tr>
     <td>.domains</td>
     <td>"all"</td>
     <td>Allows access to all domains.<br></br>Not recommended, may affect performance, security and privacy. Plugin may be blocked by enterprises.</td>
     <td>Mandatory</td>
      </tr>
      <tr>
     <td>.enableMessageBridge</td>
     <td>"localAndRemote"</td>
     <td>Allows Plugin & the content loaded on WebView to communicate regardless of where the content is loaded from **locally or remotely.**</td>
     <td>Optional</td>
      </tr>
      <tr>
     <td>.enableMessageBridge</td>
     <td>"localOnly"</td>
     <td>Allows Plugin & the content loaded on WebView to communicate if the content is loaded from **locally.** (supported from UXP v8.0.0❗)</td>
     <td>Optional</td>
      </tr>
      <tr>
     <td>.enableMessageBridge</td>
     <td>"no"</td>
     <td>Does not allow Plugin & the content loaded on WebView to communicate</td>
     <td>Optional</td>
      </tr>
    </table><br></br>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// \`manifest.json\`
{
"manifestVersion": 5,
"requiredPermissions": {
    "webview": {
       "allow": "yes",
        // domains --> string[] | "all"
        "domains": [ "https://*.adobe.com", "https://*.google.com"],
        // enableMessageBridge can use either of these data "localAndRemote" | "localOnly" | "no"
        "enableMessageBridge": "localAndRemote"
     }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Note:`}</strong><br></br>{`
You can setup a communication channel between the Webview and your plugin using `}<inlineCode parentName="p">{`postMessage`}</inlineCode>{`. Make sure that `}<inlineCode parentName="p">{`requiredPermissions.webview.enableMessageBridge`}</inlineCode>{` is set to `}<inlineCode parentName="p">{`"localAndRemote"`}</inlineCode>{` in the plugin's manifest.json, just like the above example. Find more details in the `}<inlineCode parentName="p">{`postMessage`}</inlineCode>{` property description section.`}</p>
    <h4 {...{
      "id": "sample-plugin"
    }}>{`Sample Plugin`}</h4>
    <p>{`Checkout the template available in `}<inlineCode parentName="p">{`UXP Developer Tool`}</inlineCode>{` for a quick starter plugin for WebView in UXP.`}</p>
    <h4 {...{
      "id": "limitations"
    }}>{`Limitations`}</h4>
    <ol>
      <li parentName="ol">{`UXP v7.4.3 and below allows only remote content. This means you will not be able to load local HTML files from plugin folders in UXP WebView unless you have UXP v8.0 or higher.`}</li>
      <li parentName="ol">{`Any links in a UXP WebView will not open in a new window.
e.g., In a browser, clicking `}<inlineCode parentName="li">{`<a href="https://www.adobe.com" target="_blank">`}</inlineCode>{` would create a new Window
and open `}<inlineCode parentName="li">{`https://www.adobe.com`}</inlineCode>{` from the new Window or JavaScript alert() pops up a new Window. UXP WebView doesn't permit this.`}</li>
      <li parentName="ol">{`The manifest permission `}<inlineCode parentName="li">{`requiredPermissions.webview.domains`}</inlineCode>{` does not allow `}<inlineCode parentName="li">{`wildcard(*)`}</inlineCode>{` in the top-level domain names.
e.g., Domain lists below are NOT supported`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"requiredPermissions": {
 "webview": {
     "domains": ["https://www.*", "https://www.adobe.*"],
     "allow": "yes"
  }
}
`}</code></pre>
    <h3 {...{
      "id": "load-local-content-onto-webview"
    }}>{`Load local content onto WebView`}</h3>
    <p>{`From UXP v8.0.0 onwards, UXP plugins supports loading HTML content from your plugin folder (`}<inlineCode parentName="p">{`plugin`}</inlineCode>{`, `}<inlineCode parentName="p">{`plugin-data`}</inlineCode>{` and `}<inlineCode parentName="p">{`plugin-temp`}</inlineCode>{` folders) in the Webview. You don't need to host the HTML files in a remote server anymore. `}</p>
    <p><strong parentName="p">{`Example`}</strong><br></br></p>
    <p>{`Let's assume that `}<inlineCode parentName="p">{`webview.html`}</inlineCode>{` is located in the plugin folder. You can load the HTML by using the `}<inlineCode parentName="p">{`plugin`}</inlineCode>{` protocol URL.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<webview src="plugin:/webview.html"></webview>
`}</code></pre>
    <p>{`Similarly, for webview-in-plugin-data.html in plugin-data and webview-in-plugin-temp.html in plugin-temp folder:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<webview src="plugin-data:/webview-in-plugin-data.html"></webview>
<webview src="plugin-temp:/webview-in-plugin-temp.html"></webview>
`}</code></pre>
    <p><strong parentName="p">{`Manifest Settings`}</strong><br></br>{`
To enable local content,  `}</p>
    <ol>
      <li parentName="ol"><inlineCode parentName="li">{`requiredPermissions.webview.allowLocalRendering`}</inlineCode>{` should be set to "yes".`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`requiredPermissions.webview.enableMessageBridge`}</inlineCode>{` should be either "localOnly" or "localAndRemote" for communication between the plugin and WebView via postMessage.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"requiredPermissions": {
 "webview": {
     "allow": "yes",
     "domains": [],
     "allowLocalRendering": "yes",
     "enableMessageBridge": "localOnly"
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Best Practice`}</strong><br></br>{`
Use relative path for loading resources from the WebView. `}<br></br></p>
    <p>{`The loaded HTML page in the Webview may refer to other CSS, JS, images or HTML files. Use relative paths to specify such resources. Do not use the UXP `}<inlineCode parentName="p">{`plugin:`}</inlineCode>{`, `}<inlineCode parentName="p">{`plugin-data:`}</inlineCode>{` and `}<inlineCode parentName="p">{`plugin-temp:`}</inlineCode>{` protocol. For example, if you were referencing a CSS file within `}<inlineCode parentName="p">{`webview.html`}</inlineCode>{` in the above example using an absolute path "plugin:/main.css", the WebView will be unable to load the resource. Use as a relative path such as "./main.css" instead. `}</p>
    <p><strong parentName="p">{`Extra Tip`}</strong><br></br>{`
Find the root folders of 'plugin', 'plugin-data', and 'plugin-temp' in the following way.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`// manifest.json
"requiredPermissions": {
  // permission for localFileSystem
  "localFileSystem": "request"
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const localFileSystem = require("uxp").storage.localFileSystem;
const pluginFolder = await localFileSystem.getPluginFolder();
const pluginDataFolder = await localFileSystem.getDataFolder();
const tempFolder = await localFileSystem.getTemporaryFolder();

console.log(\`pluginFolder = \${pluginFolder.nativePath}\`);
console.log(\`pluginDataFolder = \${pluginDataFolder.nativePath}\`);
console.log(\`pluginTempFolder = \${tempFolder.nativePath}\`);
`}</code></pre>
    <p><strong parentName="p">{`Limitations`}</strong><br></br>{`
For security reasons, WebView does not support JS localStorage APIs if local contents are loaded onto WebView.
When the local contents access the properties (length) or methods (setItem, getItem and so on) of JS localStorage property,
it would return nothing (zero or null according to the return type) or throw an error.`}</p>
    <a name="htmlwebviewelement-htmlwebviewelement-new" id="htmlwebviewelement-htmlwebviewelement-new"></a>
    <h2 {...{
      "id": "htmlwebviewelement-1"
    }}>{`HTMLWebViewElement()`}</h2>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`uxpallowinspector`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enable Developer tools for debugging in UXP WebView`}<br></br>{`                                       `}<strong parentName="td">{`Note:`}</strong>{` Not supported in UWP platform`}<br></br>{`                                       eg: `}<inlineCode parentName="td">{`<webview id="webviewsample" width="100%" height="360px" src="https://www.adobe.com" uxpAllowInspector="true" ></webview>`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`src`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The url to load in the WebView`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Width of the WebView`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`height`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Height of the WebView`}</td>
        </tr>
      </tbody>
    </table>
    <a name="htmlwebviewelement-src" id="htmlwebviewelement-src"></a>
    <h3 {...{
      "id": "src--string"
    }}>{`src : `}<inlineCode parentName="h3">{`string`}</inlineCode></h3>
    <p>{`The url to load in the WebView.`}</p>
    <a name="htmlwebviewelement-postmessage" id="htmlwebviewelement-postmessage"></a>
    <h3 {...{
      "id": "postmessagemessage-targetorigin-transfer"
    }}>{`postMessage(message, targetOrigin, transfer)`}</h3>
    <p>{`The plugin and the content within the WebView can communicate with each other using `}<inlineCode parentName="p">{`postMessage`}</inlineCode>{` and listening to the 'message' event.`}</p>
    <p>{`[Plugin]`}</p>
    <ul>
      <li parentName="ul">{`send messages to the content in the WebView `}<inlineCode parentName="li">{`HTMLWebViewElement.postMessage(msg)`}</inlineCode></li>
      <li parentName="ul">{`receive messages from the content in the WebView `}<inlineCode parentName="li">{`window.addEventListener("message", (e) => {...})`}</inlineCode>{` where `}<inlineCode parentName="li">{`e: Event { origin: url of the content, source: window.HTMLWebViewElement, data: message }`}</inlineCode></li>
    </ul>
    <p>{`[Content in the WebView]`}</p>
    <ul>
      <li parentName="ul">{`send messages to plugin `}<inlineCode parentName="li">{`window.uxpHost.postMessage(msg)`}</inlineCode></li>
      <li parentName="ul">{`receive messages from plugin `}<inlineCode parentName="li">{`window.addEventListener("message", (e) => { ... })`}</inlineCode>{` where `}<inlineCode parentName="li">{`e: Event { origin: plugin id, source: window.uxpHost, data: message }`}</inlineCode></li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A message sent to the WebView. Please note that the message is stringified & parsed by JSON`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`targetOrigin`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`[Optional]`}</inlineCode>{` - The origin of WebView for the event to be dispatched. The literal string "*" indicates no preference`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`transfer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Optional`}</inlineCode>{` and `}<inlineCode parentName="td">{`not functional yet`}</inlineCode>{`. Will be enabled in future release.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Send message from plugin to WebView
let webViewDisplay = document.getElementById("webviewSample");
webViewDisplay.postMessage("PluginMessage1");

// Plugin receives message from WebView via "message" event.
window.addEventListener("message", (e) => {
  console.log(\`Message from WebView(Origin:\${e.origin}): \${e.data}\\n\`);

  if (e.data === "webviewmessage1") {
    webViewDisplay.postMessage("Thanks, Message1 recieved successfully");
  }
});
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// WebView sends message to Plugin
window.uxpHost.postMessage("webviewmessage1");

// WebView receives messages from Plugin
window.addEventListener("message", (e) => {
  // (e) from Plugin
  // e.origin would be 'plugin id'
  // e.source would be 'window.uxpHost'
  // e.data is 'JSON.parse(JSON.stringify("PluginMessage1"))' which is "PluginMessage1"
  if (e.data === "PluginMessage1") {
    console.log(e.data);
  }
});
`}</code></pre>
    <a name="htmlwebviewelement-event-loadstart" id="htmlwebviewelement-event-loadstart"></a>
    <h3 {...{
      "id": "loadstart"
    }}>{`loadstart`}</h3>
    <p>{`Event fired when loading has started.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"loadstart"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`url which WebView navigates to`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const webview = document.getElementById("webviewSample");
// Print the url when loading has started
webview.addEventListener("loadstart", (e) => {
  console.log(\`webview.loadstart \${e.url}\`);
});
`}</code></pre>
    <a name="htmlwebviewelement-event-loadstop" id="htmlwebviewelement-event-loadstop"></a>
    <h3 {...{
      "id": "loadstop"
    }}>{`loadstop`}</h3>
    <p>{`Event fired when loading has completed.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"loadstop"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`url which WebView navigates to`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Print the url when loading has completed
webview.addEventListener("loadstop", (e) => {
  console.log(\`webview.loadstop \${e.url}\`);
});
`}</code></pre>
    <a name="htmlwebviewelement-event-loaderror" id="htmlwebviewelement-event-loaderror"></a>
    <h3 {...{
      "id": "loaderror"
    }}>{`loaderror`}</h3>
    <p>{`Event fired when loading has failed.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"loaderror"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`url which WebView navigates to`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Platform specific error code. Below are the Error Code details for the following platforms`}<br></br>{` 1. `}<a parentName="td" {...{
              "href": "https://developer.apple.com/documentation/foundation/1448136-nserror_codes"
            }}>{`Mac Error Codes`}</a><br></br>{` 2. `}<a parentName="td" {...{
              "href": "https://learn.microsoft.com/en-us/dotnet/api/microsoft.web.webview2.core.corewebview2weberrorstatus?view=webview2-dotnet-1.0.1587.40"
            }}>{`Windows Error Code`}</a><br></br>{` 3. `}<a parentName="td" {...{
              "href": "https://learn.microsoft.com/en-us/windows/win32/seccrypto/common-hresult-values"
            }}>{`Windows Common HRESULT codes`}</a><br></br></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Error description`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Print the url, code and message when loading has failed
webview.addEventListener("loaderror", (e) => {
     console.log(\`webview.loaderror \${e.url}, code:\${e.code}, message:\${e.message}\`);
});
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      